module.exports = __webpack_public_path__ + "static/stardust-image-default-d9fafa0adcdb3b99c73cfb8524809103.png";